import { VideoAsset } from '../../state/modules/video/types';
import formatVideoAssetTimecode from './formatVideoAssetTimecode';

const formatVideoAssetDuration = (asset: VideoAsset): string =>
  formatVideoAssetTimecode(asset.duration, asset);

export default formatVideoAssetDuration;
